import PropTypes from 'prop-types';
import DateTime from '../../common/DateTime';
import useLocalize from '../../../utils/hooks/useLocalize';
import './ScanCardTimestamp.scss';

/**
 * ScanCardTimestamp component - displays the scan creation or update timestamp
 * @param {string} created - ISO timestamp of scan creation
 * @param {string} updated - ISO timestamp of scan last update
 * @returns React component that renders the timestamp section
 */
const ScanCardTimestamp = ({ created = '', updated = '' }) => {
  const translate = useLocalize();

  /**
   * Determine if timestamp is from creation or update
   */
  const getTimestampInfo = () => {
    // If updated is different from created, show updated
    if (updated && created && updated !== created) {
      return {
        timestamp: updated,
        label: translate('desktop.scans.myscans.updated')
      };
    }
    // Otherwise show created
    return {
      timestamp: created,
      label: translate('desktop.scans.myscans.created')
    };
  };

  const timestampInfo = getTimestampInfo();

  return (
    <span className="scan-card-timestamp">
      <DateTime
        format="YYYY/MM/DD HH:mm"
        value={timestampInfo.timestamp}
        suffix={` ${timestampInfo.label}`}
      />
    </span>
  );
};

ScanCardTimestamp.propTypes = {
  created: PropTypes.string,
  updated: PropTypes.string
};

export default ScanCardTimestamp;
